import { render, staticRenderFns } from "./lista-edital.vue?vue&type=template&id=2d96140f&"
import script from "./lista-edital.vue?vue&type=script&lang=js&"
export * from "./lista-edital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports